import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { DailyleafCollectionRouteWiseTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DailyLeafCollectionRouteWiseSummarySchemaObject } from "../DailyLeafCollectionRouteWiseSummaryReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from "lodash";
import '../Pages/tableFooter.css';
import xlsx from 'json-as-xlsx';

const screenCode = "DAILYLEAFCOLLECTIONROUTEWISESUMMARYREPORT";

export function DailyLeafCollectionRouteWiseSummaryReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        date: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(DailyLeafCollectionRouteWiseSummarySchemaObject).options({ allowUnknown: true });
    const [contentRowNames, setContentRowNames] = useState([]);
    const [headerNames, setHeaderNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvData, setCsvData] = useState([]);

    const initialContentRowNames = ["name", "registrationNumber"];
    const initialHeaderNames = ["Name", "Registration Number"];
    const initalCsvHeaders = [
        { label: "Name", value: "name" },
        { label: "Registration Number", value: "registrationNumber" }
    ];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
        clearTabeData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
        clearTabeData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTabeData();
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            date: target.value,
        });
        clearTabeData();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyLeafCollectionRouteWiseSummarySchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYLEAFCOLLECTIONROUTEWISESUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getDailyLeafCollectionRouteWiseReportData(leafCollectionDetails);

        var mergedData = mergeFieldAndFactoryDataByTag(result);

        var mergedResults = mergeDataByCustomer(mergedData.resultsArray);

        var copyofInitialHeaderNames = initialHeaderNames;
        var copyofContentRowNames = initialContentRowNames;
        var copyofCsvHeaders = initalCsvHeaders;

        copyofContentRowNames.push(...mergedData.collectionIdArray);

        mergedData.collectionIdArray.forEach(x => {
            var isAvailable = copyofInitialHeaderNames.find(y => y === x);
            if (!isAvailable) {
                var selectedItem = mergedData.collectionTypesArray.find(y => y.value === x);
                if (selectedItem.value.includes("Fi")) {
                    copyofInitialHeaderNames.push("Field " + selectedItem.name);
                    copyofCsvHeaders.push({ label: "Field " + selectedItem.name, value: selectedItem.value });
                } else if (selectedItem.value.includes("Fa")) {
                    copyofInitialHeaderNames.push("Factory " + selectedItem.name);
                    copyofCsvHeaders.push({ label: "Factory " + selectedItem.name, value: selectedItem.value })
                }
            }
        });

        copyofInitialHeaderNames.push("Field Total", "Factory Total");
        copyofCsvHeaders.push({ label: "Field Total", value: "fieldTotal" }, { label: "Factory Total", value: "factoryTotal" })
        copyofContentRowNames.push("fieldTotal", "factoryTotal");

        var total = [];
        var totalRow = {
            name: "Total"
        }

        mergedResults.forEach(x => {
            for (var property in x) {
                if (property !== "customerID" && property !== "name"
                    && property !== "tagNumber" && property !== "registrationNumber") {
                    total.push({ name: property, value: x[property] });
                    totalRow[property] = (totalRow[property] === undefined ? 0 : totalRow[property]) +
                        (x[property] === undefined ? 0 : x[property]);
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        setFullTotalRow(res);

        var copyOfmergedResults = _.cloneDeep(mergedResults);
        copyOfmergedResults.push(totalRow);
        copyOfmergedResults.unshift({}, {
            name: "Current Date: " + new Date().toLocaleString(),
            registrationNumber: "User: " + tokenService.getUserNameFromToken()
        }, {});

        setHeaderNames(copyofInitialHeaderNames);
        setContentRowNames(copyofContentRowNames);
        setCsvHeaders(copyofCsvHeaders)

        if (mergedResults.length > 0) {
            setIsTableHide(false);
            setCsvData(copyOfmergedResults);
            setReportData(mergedResults);
            createDataTable();
        }
    }

    function mergeDataByCustomer(data) {

        var result = [];

        data.forEach(x => {

            if (result.length === 0) {
                result.push(x);
            } else {
                var selectedItem = result.find(y => y.customerID === x.customerID);
                if (selectedItem) {
                    for (var property in x) {
                        if (property !== "customerID" && property !== "name" && property !== "tagNumber" && property !== "registrationNumber") {
                            selectedItem[property] = (selectedItem[property] === undefined ? 0 : selectedItem[property]) +
                                (x[property] === undefined ? 0 : x[property]);
                        }
                    }
                    selectedItem.fieldTotal = checkUndefined(x.total) + checkUndefined(selectedItem.fieldTotal);
                    selectedItem.factoryTotal = checkUndefined(x.netAmount) + checkUndefined(selectedItem.factoryTotal);
                } else {
                    result.push(x);
                }
            }

        });

        return result;
    }

    function mergeFieldAndFactoryDataByTag(data) {

        var fieldData = data.fieldData;
        var factoryData = data.factoryData;
        var result = [];
        var matchingRecords = [];
        var collectionTypes = [];
        var collectionIds = [];

        fieldData.forEach(x => {
            factoryData.forEach(y => {
                if (y.tagNumber.toString() === x.tagNumber.toString()) {
                    var singleRecord = {
                        name: x.nameToBePrinted,
                        [x.collectionTypeID + "Fi"]: x.total,
                        [x.collectionTypeID + "Fa"]: y.netAmount,
                        tagNumber: x.tagNumber.toString(),
                        customerID: x.customerID,
                        registrationNumber: x.registrationNumber,
                        fieldTotal: x.total,
                        factoryTotal: y.netAmount
                    }
                    result.push(singleRecord);
                    matchingRecords.push(x.tagNumber.toString());

                    collectionTypes.push({ value: x.collectionTypeID + "Fi", name: x.collectionTypeName });
                    collectionTypes.push({ value: x.collectionTypeID + "Fa", name: x.collectionTypeName });

                    collectionIds.push(x.collectionTypeID + "Fi");
                    collectionIds.push(x.collectionTypeID + "Fa");

                }
            });
        });

        fieldData.forEach(x => {
            var res = matchingRecords.find(y => y === x.tagNumber);
            if (!res) {
                var singleRecord = {
                    name: x.nameToBePrinted,
                    [x.collectionTypeID + "Fi"]: x.total,
                    tagNumber: x.tagNumber,
                    customerID: x.customerID,
                    registrationNumber: x.registrationNumber,
                    fieldTotal: x.total
                }
                result.push(singleRecord);

                collectionTypes.push({ value: x.collectionTypeID + "Fi", name: x.collectionTypeName });
                collectionIds.push(x.collectionTypeID + "Fi");
            }
        })

        return {
            collectionTypesArray: collectionTypes.filter((v, i, a) => a.findIndex(t => (t.value === v.value && t.name === v.name)) === i),
            collectionIdArray: [...new Set(collectionIds)],
            resultsArray: result
        };
    }

    function checkUndefined(value) {
        if (value === undefined) {
            return 0;
        } else {
            return value;
        }
    }

    function destroyDataTable() {
        $('#reportTable').DataTable().destroy();
    }

    function createDataTable() {
        $('#reportTable').DataTable({
            "aaSorting": []
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Leaf Collection Report',
            fileName: 'DailyLeafCollectionRouteWiseReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            date: ""
        });
        setErrors("");
        clearTabeData();
    }

    function clearTabeData() {
        setIsTableHide(true);
        destroyDataTable();
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.date,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Daily Leaf Collection Route Wise Summary Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="reportTable" className="display dataTable no-footer">
                                                    <thead>
                                                        <tr>
                                                            {headerNames.map((x, index) => {

                                                                var align = (x === "Name" || x === "Registration Number") ? "left" : "right";

                                                                return (
                                                                    <th style={{ textAlign: align }} key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <DailyleafCollectionRouteWiseTableContent
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="2">Total</th>
                                                            {
                                                                contentRowNames.map((x, i) => {
                                                                    var res = fullTotalRow.find(y => y.name.toString() === x.toString());
                                                                    if (res) {
                                                                        return (
                                                                            <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                        );
                                                                    }
                                                                })
                                                            }
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Daily Leaf Collection Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} fullTotalRow={fullTotalRow}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} headerNames={headerNames} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
